var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register" }, [
    _c(
      "body",
      {
        staticClass: "account-page",
        staticStyle: {
          "font-family": "'CircularStd', sans-serif",
          "font-size": ".9375rem",
          color: "#1f1f1f",
          "background-color": "#f7f7f7",
          "min-height": "100%",
          "overflow-x": "hidden"
        }
      },
      [
        _c("div", { staticClass: "main-wrapper" }, [
          _c("div", { staticClass: "account-content" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "account-logo" },
                [
                  _c("router-link", { attrs: { to: "/index" } }, [
                    _c("img", {
                      attrs: { src: _vm.logoText, alt: _vm.appTitle }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "account-box" }, [
                _c(
                  "div",
                  { staticClass: "account-wrapper" },
                  [
                    _vm.isSuccess == false
                      ? _c("h3", { staticClass: "account-title" }, [
                          _vm._v("Check Confirmation")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSuccess == true
                      ? _c("h3", { staticClass: "account-title" }, [
                          _vm._v("Create a New Password")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSuccess == true
                      ? _c(
                          "form",
                          {
                            staticClass: "was-validated",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.updatePasswordForgot($event)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Password New")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.fieldsPass.member_password_new,
                                    expression: "fieldsPass.member_password_new"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "password", required: "" },
                                domProps: {
                                  value: _vm.fieldsPass.member_password_new
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.fieldsPass,
                                      "member_password_new",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Repeat Password")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.fieldsPass.member_password_new_repeat,
                                    expression:
                                      "fieldsPass.member_password_new_repeat"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "password", required: "" },
                                domProps: {
                                  value:
                                    _vm.fieldsPass.member_password_new_repeat
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.fieldsPass,
                                      "member_password_new_repeat",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group text-center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary account-btn",
                                    attrs: {
                                      disabled: _vm.isDisabled == 1,
                                      type: "submit"
                                    }
                                  },
                                  [_vm._v("Update")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "account-footer" }, [
                              _c(
                                "p",
                                [
                                  _vm._v(
                                    "\n                    Don't have an account yet?\n                    "
                                  ),
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/register" } },
                                    [_vm._v("Register")]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("center", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-md",
                          attrs: { disabled: _vm.isDisabled, type: "submit" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push("/")
                            }
                          }
                        },
                        [_vm._v("« Back to Home")]
                      )
                    ])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cb42636", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb42636","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/forgot/check.vue
// module id = null
// module chunks = 